import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="relative flex min-h-[calc(100vh-64px)] items-center justify-center overflow-hidden px-4 py-16" data-testid="payment-cancel-page">
      <img src="/assets/mandala-arrow.jpeg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
      <div className="absolute inset-0 bg-cream/60" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md rounded-3xl border border-terra/15 bg-white/90 p-10 text-center shadow-card backdrop-blur-md"
      >
        <h1 className="font-serif text-2xl font-medium text-ink" data-testid="payment-cancel-title">Paiement annulé</h1>
        <p className="mt-2 text-sm leading-relaxed text-clay">Aucun souci — rien n'a été débité. Les cartes restent face cachée, prêtes quand vous l'êtes.</p>
        <Link to="/quiz" data-testid="payment-cancel-retry" className="mt-6 inline-flex items-center gap-2 rounded-full bg-terra px-7 py-3.5 text-sm font-semibold text-cream shadow-boho transition-all duration-300 hover:bg-terra-dark">
          <RotateCcw size={15} /> Réessayer
        </Link>
      </motion.div>
    </div>
  );
}
